<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="logo-edit" ref="logoEdit" @click.stop>
    <el-form :model="formData">
      <!-- <el-form-item label="文字：" v-show="topContent !== null">
        <el-input v-model="topContent"></el-input>
      </el-form-item> -->
      <el-form-item label="字号：">
        <el-select v-model="formData.fontSize" placeholder="请选择">
          <el-option
            v-for="item in fontSize"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="字体：">
        <el-select v-model="formData.fontFamily" placeholder="请选择">
          <el-option
            v-for="item in fontFamily"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="设置：">
        <div class="font-set">
          <div
            class="font-set-color"
            @click.stop="handleOpenColorCheck"
            :style="{ background: formData.color ? formData.color : '' }"
          ></div>

          <div
            class="chice-text-weight"
            :class="{
              'chice-active': formData.fontWeight === '600',
            }"
            @click="handleTextWeight"
          >
            <i class="iconfont icon-a-jiacufuzhi4"></i>
          </div>
          <div
            class="chice-text-xie"
            :class="{
              'chice-active': formData.fontStyle === 'italic',
            }"
            @click="handleTextStyle"
          >
            <i class="iconfont icon-a-xietifuzhi4"></i>
          </div>
          <div
            class="chice-text-dec"
            :class="{
              'chice-active': formData.textDecoration === 'underline',
            }"
            @click="handleTextDec"
          >
            <i class="iconfont icon-a-zitixiahuaxianfuzhi4"></i>
          </div>

          <div>
            <el-dropdown trigger="click" @command="handleAlignChoice">
              <i
                class="iconfont"
                :class="alignIcon ? alignIcon : 'icon-a-shangxiafuzhi4'"
              ></i>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="left"
                    ><i class="iconfont icon-juzuoduiqi"></i
                    ><span>左对齐</span></el-dropdown-item
                  >
                  <el-dropdown-item command="right"
                    ><i class="iconfont icon-juyouduiqi"></i
                    ><span>右对齐</span></el-dropdown-item
                  >
                  <el-dropdown-item command="center"
                    ><i class="iconfont icon-paixu"></i
                    ><span>居中对齐</span></el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </el-form-item>
      <div @click.stop="isShowColor = true">
        <sketch-picker
          v-model="colors"
          @input="updateValue"
          v-if="isShowColor"
          :style="{ top: colorPosition === 'top' ? '' : '-200px' }"
          class="back-color-picker"
        ></sketch-picker>
      </div>
    </el-form>
  </div>
</template>

<script>
// import { Sketch } from 'vue-color'
import { debounce } from 'lodash'

export default {
  name: 'editModal',
  data () {
    return {
      dialogVisible: false,
      formData: {
        fontSize: '12px',
        fontFamily: '微软雅黑',
        fontWeight: 'normal', // 是否加粗
        fontStyle: 'normal', // 是否斜体
        textDecoration: 'none', // 是否下划线
        // lineHeight: "12px", //选择的行高
        color: '#ccc', // 选择的颜色
        textAlign: 'center' // 位置排版
      },
      fontSize: ['12px', '14px', '16px', '18px', '20px', '22px', '24px'], // 自号的选择
      fontFamily: ['微软雅黑', '宋体', '仿宋'], // 字体的选择
      colors: {}, // 颜色选择器绑定的颜色
      isShowColor: false, // 是否显示颜色选择器
      isShowLineHeightSel: false, // 是否显示选择行高多选框
      alignIcon: '' // 对齐选择之后，icon改变
    }
  },

  components: {
    // SketchPicker: Sketch
  },
  props: {
    colorPosition: {
      type: String,
      default: 'top'
    },
    columnFont: {
      type: Object,
      default: function () {
        return {
          fontSize: '12px',
          fontFamily: '微软雅黑',
          fontWeight: 'normal', // 是否加粗
          fontStyle: 'normal', // 是否斜体
          textDecoration: 'none', // 是否下划线
          // lineHeight: "12px", //选择的行高
          color: '#ccc', // 选择的颜色
          textAlign: 'center' // 位置排版
        }
      }
    },
    // topContent: {
    //   type: String,
    //   default: null
    // },
    isCard: {
      type: Boolean,
      default: false
    }
  },
  created () {
    if (Object.keys(this.columnFont).length !== 0) {
      this.formData = { ...this.columnFont }
    }
  },

  mounted () {},

  methods: {
    updateValue: debounce(function (value) {
      this.formData.color = `rgba(${value.rgba.r},${value.rgba.g},${value.rgba.b},${value.rgba.a})`
    }, 200),
    handleOpenColorCheck () {
      this.isShowColor = true

      // 点击选择行颜色时,为了提高交互，行高的显示要变成false
      this.isShowLineHeightSel = false
      this.$refs.logoEdit.addEventListener('click', this.removeWindowClick)
    },
    removeWindowClick () {
      this.isShowColor = false
      this.isShowLineHeightSel = false
      this.$refs.logoEdit.removeEventListener('click', this.removeWindowClick)
    },
    handleTextWeight () {
      if (this.formData.fontWeight === 'normal') {
        this.formData.fontWeight = '600'
      } else {
        this.formData.fontWeight = 'normal'
      }
    },
    handleTextStyle () {
      switch (this.formData.fontStyle) {
        case 'italic':
          this.formData.fontStyle = 'normal'
          break
        case 'normal':
          this.formData.fontStyle = 'italic'
          break
      }
    },
    handleTextDec () {
      switch (this.formData.textDecoration) {
        case 'underline':
          this.formData.textDecoration = 'none'
          break

        case 'none':
          this.formData.textDecoration = 'underline'
          break
      }
    },
    handleShowSelect () {
      this.isShowLineHeightSel = true
      // 点击选择行行高时,为了提高交互，颜色的显示要变成false
      this.isShowColor = false

      this.$refs.logoEdit.addEventListener('click', this.removeWindowClick)
    },
    handleAlignChoice (item) {
      this.formData.textAlign = item
      switch (item) {
        case 'left':
          this.alignIcon = 'icona-icon-juzuoduiqi'
          break
        case 'right':
          this.alignIcon = 'icon-juyouduiqi'
          break
        case 'center':
          this.alignIcon = 'icon-paixu'
          break
      }
    },
    handleClose () {
      this.$emit('close', false)
    }
  },
  watch: {
    formData: {
      handler: function () {
        if (this.isCard) {
          this.$emit('update:columnFont', JSON.parse(JSON.stringify(this.formData)))
        } else {
          this.$emit('change-all-font', this.formData)
        }
      },
      deep: true
    },
    topContent () {
      this.$emit('change-top-content', this.topContent)
    }
  },
  beforeUnmount () {
    document.removeEventListener('click', this.removeWindowClick)
  },
  computed: {}
}
</script>

<style lang='scss' scoped>
.logo-edit {
  width: 218px;
  // height: 131px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.14);
  background: #fff;
  color: #000;
  position: relative;
  .logo-edit-close {
    position: absolute;
    font-size: 16px;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  ::v-deep .el-form {
    padding: 15px;
    position: relative;
    .el-form-item {
      margin-bottom: 10px;
      &:nth-child(4) {
        .el-form-item__label {
          margin: 0;
        }
      }
      .el-form-item__label {
        font-size: 12px;
        line-height: normal;
        padding: 0;
        margin: 9px 0;
      }
    }
    .el-form-item__content {
      line-height: normal;
      .font-set {
        height: 16px;
        line-height: 34px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .iconfont {
          cursor: pointer;
          font-size: 12px;
        }
        .font-set-color {
          width: 13px;
          height: 13px;
          background: #000;
          box-sizing: border-box;
          border: solid 1px #eee;
          border-radius: 50%;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
        .chice-text-weight {
          height: 20px;
          width: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 2px;
        }
        .chice-text-xie {
          height: 20px;
          width: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 2px;
        }
        .chice-line-hight {
          display: flex;
          justify-content: center;
          align-items: center;
          .bottom-icon {
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 6px solid #999999;
          }
        }
        .check-alignment-options {
          position: absolute;
          top: -160px;
        }

        .el-select {
          height: 16px;
          line-height: normal;
          .el-input {
            width: 33px;
            position: relative;
            .el-input__inner {
              width: 33px;
              height: 20px;
              padding: 0;
            }
            .el-input__suffix {
              display: none;
              position: absolute;
              left: 20px;
              top: -5px;
            }
          }
        }
        .chice-text-dec {
          height: 20px;
          width: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 2px;
          border-right: 1px #d8d8d8 solid;
        }
        .chice-active {
          background: rgba(68, 226, 226, 0.651);
        }
      }
      .el-input {
        width: 110px;
        height: 34px;
        .el-input__inner {
          height: 34px;
          font-size: 12px;
        }
      }
      .el-select {
        .el-input {
          width: 110px;
          height: 34px;
          .el-input__inner {
            height: 34px;
            font-size: 12px;
          }
        }
      }
    }
  }
  .back-color-picker {
    position: absolute;
    z-index: 999;
    top: 130px;
    left: -50px;
  }
}
</style>
